// extracted by mini-css-extract-plugin
export default {"hideTooltip":"A--z","fadeIn":"B--z","delay":"C--z","recommendedSizeTooltip":"D--z"};